import React from "react";
import { FormattedDate } from "react-intl";
import { TableCell } from "@material-ui/core";

const RelatedServiceProviderRemoveTableCell = ({ serviceProvider }) => {
  return (
    <TableCell>
      {!!serviceProvider.removeDate && (
        <FormattedDate value={serviceProvider.removeDate} />
      )}
    </TableCell>
  );
};

export default RelatedServiceProviderRemoveTableCell;
